/*
 * © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */

var getFirstChar = function getFirstChar(str) {
  var _str$codePointAt;
  return String.fromCodePoint((_str$codePointAt = str.codePointAt(0)) !== null && _str$codePointAt !== void 0 ? _str$codePointAt : 0);
};

/**
 * Implementation Guidance:
 * 1.One word Display Names show first letter only (Kammi = K)
 * 2.Two word Display names show first letter of first word plus first letter of second word (Ms. Sheeler = MS)
 * 3.Display names with more than 2 words will show first letter of first word plus first letter of second word only (Ms. Kammi Sheeler = MK)
 * @param profile
 * @returns
 *
 */
export var generateAvatarInitials = function generateAvatarInitials(profile) {
  if (profile !== null && profile !== void 0 && profile.displayName) {
    var displayNameArray = profile.displayName.split(' ');
    var firsLetter = displayNameArray[0] ? getFirstChar(displayNameArray[0]).toUpperCase() : '';
    var secondLetter = displayNameArray[1] ? getFirstChar(displayNameArray[1]).toUpperCase() : '';
    return firsLetter + secondLetter;
  }
  return '';
};